import React, { useCallback, useState } from 'react';
import { useModal } from 'react-modal-hook';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsTipCalcFormDirty, setCurrentSite } from 'store/App';
import { LoadingSkeleton } from '../../screens/SiteSettings/styles';
import { IEmployerSite } from '../../types';
import { AlertContent } from '../Alert';
import { ModalFactory } from '../Modal';
import ConnectedSiteSelector from './ConnectedSiteSelector';

const TipCalculatorSiteSelector = () => {
  const dispatch = useDispatch();
  const [siteToConfirm, setSiteToConfirm] = useState<IEmployerSite>();
  const [showSelect, setShowSelect] = useState(true);
  const isTipCalcFormDirty = useSelector(selectIsTipCalcFormDirty);

  const onConfirmSiteSelect = (site: IEmployerSite) => dispatch(setCurrentSite(site.id));

  const handleSiteSelect = useCallback(
    (selected: IEmployerSite) => {
      if (selected) {
        if (isTipCalcFormDirty) {
          setShowSelect(false);
          setSiteToConfirm(selected);
          showConfirmModal();
        } else {
          onConfirmSiteSelect(selected);
        }
      }
    },
    [isTipCalcFormDirty]
  );

  const onClose = () => {
    setShowSelect(true);
    hideConfirmModal();
  };

  const [showConfirmModal, hideConfirmModal] = useModal(
    () => (
      <ModalFactory customModal onClose={hideConfirmModal} isActive closeOnOutSideClick={false}>
        <AlertContent
          title="Warning"
          message="Changing your site will delete all unsaved rules. Do you want to proceed?"
          leftActionLabel="Cancel"
          rightActionLabel="Proceed"
          onClose={onClose}
          onLeftAction={onClose}
          onRightAction={() => {
            onConfirmSiteSelect(siteToConfirm);
            onClose();
          }}
        />
      </ModalFactory>
    ),
    [siteToConfirm]
  );

  return showSelect ? <ConnectedSiteSelector onSiteSelect={handleSiteSelect} /> : <LoadingSkeleton />;
};

export default TipCalculatorSiteSelector;
